/* Pop-up de newsletter de Salty Dogs.
 *
 * Tres cosas: enviar el alta sin recargar la pagina, pasar al estado del
 * codigo, y copiar el codigo al portapapeles. El disparador (retraso, cookie
 * de dias, "no volver a mostrar") lo sigue manejando el tema.
 */
(function () {
  'use strict';

  function init(raiz) {
    if (!raiz || raiz.dataset.sdListo === '1') return;
    raiz.dataset.sdListo = '1';

    var form = raiz.querySelector('[data-sd-nl-form]');
    var error = raiz.querySelector('[data-sd-nl-error]');
    var panelTxt = raiz.querySelector('[data-sd-nl-paneltxt]');
    var est1 = raiz.querySelector('[data-sd-nl-estado="inicial"]');
    var est2 = raiz.querySelector('[data-sd-nl-estado="ok"]');

    function mostrarError(msg) {
      if (!error) return;
      error.textContent = msg;
      error.hidden = false;
    }

    // El tema solo deja la cookie de "ya lo vio" cuando se cierra con SU boton
    // (evento dialog:close). Si el visitante cierra con Escape, con el fondo, o
    // si la pagina recarga, la cookie nunca se escribe y el pop-up vuelve a los
    // segundos. Al que ya se suscribio no le tiene que volver a aparecer nunca,
    // asi que la dejamos nosotros apenas el alta sale bien.
    function marcarVisto() {
      try {
        var host = raiz.closest('sys-newsletter');
        if (!host) return;
        var cfg = JSON.parse(host.getAttribute('configs') || '{}');
        if (!cfg.id) return;
        var dias = parseInt(raiz.dataset.dias, 10);
        if (!dias || dias < 1) dias = 180;
        var d = new Date();
        d.setTime(d.getTime() + dias * 24 * 60 * 60 * 1000);
        document.cookie = 'theme4:newsletter:' + cfg.id +
          '=shown; expires=' + d.toUTCString() + '; path=/';
      } catch (e) {}
    }

    // /discount/<codigo> deja el descuento pegado a la sesion del visitante.
    // Lo pedimos en segundo plano: no navega, solo se lleva la cookie.
    function aplicarDescuento() {
      if (raiz.dataset.autoaplicar === '0') return;
      var cod = (raiz.dataset.codigo || '').trim();
      if (!cod) return;
      try {
        fetch('/discount/' + encodeURIComponent(cod), {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store'
        }).catch(function () {});
      } catch (e) {}
    }

    function irAlCodigo() {
      marcarVisto();
      if (est1) est1.hidden = true;
      if (est2) est2.hidden = false;
      raiz.dataset.estado = 'ok';
      if (panelTxt && raiz.dataset.panelOk) panelTxt.textContent = raiz.dataset.panelOk;
      // Que el lector de pantalla anuncie el cambio
      if (est2) {
        est2.setAttribute('tabindex', '-1');
        est2.focus({ preventScroll: true });
      }
    }

    // ---- Alta sin recargar --------------------------------------------
    //
    // El formulario postea a un iframe oculto (target). No prevenimos el envio:
    // la proteccion antispam de Shopify (hCaptcha) se engancha al submit y lo
    // reenvia por su cuenta con form.submit(), que no dispara el evento y no se
    // puede frenar. Antes eso recargaba la pagina un segundo despues de mostrar
    // el codigo. Con el target, esa respuesta cae en el iframe y el pop-up no se
    // mueve; nosotros solo escuchamos cuando el iframe termino de cargar.
    var sink = raiz.querySelector('[data-sd-nl-sink]');

    if (form && sink) {
      var enviando = false;

      form.addEventListener('submit', function () {
        var email = form.querySelector('input[type="email"]');
        if (email && !email.checkValidity()) return; // que avise el navegador
        if (enviando) return;
        enviando = true;

        if (error) error.hidden = true;
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');

        var resuelto = false;
        var terminar = function () {
          if (resuelto) return;
          resuelto = true;
          if (btn) btn.removeAttribute('aria-busy');
          irAlCodigo();
        };

        sink.addEventListener('load', terminar);
        // Red lenta o captcha trabado: igual le damos el codigo.
        setTimeout(terminar, 10000);
      });
    } else if (form) {
      // Sin iframe (marcado viejo en cache): al menos no perdemos el alta.
      form.addEventListener('submit', function () {
        setTimeout(irAlCodigo, 1200);
      });
    }

    // ---- Copiar el codigo ---------------------------------------------
    var copiar = raiz.querySelector('[data-sd-nl-copy]');
    var code = raiz.querySelector('[data-sd-nl-code]');
    if (copiar && code) {
      copiar.addEventListener('click', function () {
        var txt = (code.textContent || '').trim();
        aplicarDescuento();
        var listo = function () {
          copiar.textContent = copiar.dataset.copiado;
          copiar.classList.add('is-copiado');
          setTimeout(function () {
            copiar.textContent = copiar.dataset.copiar;
            copiar.classList.remove('is-copiado');
          }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(txt).then(listo, listo);
        } else {
          // Respaldo para navegadores sin API de portapapeles
          var t = document.createElement('textarea');
          t.value = txt;
          t.setAttribute('readonly', '');
          t.style.position = 'absolute';
          t.style.left = '-9999px';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t);
          listo();
        }
      });
    }

    // ---- Cerrar ---------------------------------------------------------
    var cerrar = raiz.querySelector('[data-sd-nl-close]');
    if (cerrar) {
      cerrar.addEventListener('click', function () {
        if (raiz.dataset.estado === 'ok') marcarVisto();
        var dialogo = raiz.closest('dialog');
        if (!dialogo) return;
        // El boton de cierre del tema es el que ademas deja la cookie
        var propio = dialogo.querySelector('.hdt-dialog-btn__close');
        if (propio) propio.click();
        else if (dialogo.close) dialogo.close();
      });
    }
  }

  function buscar() {
    document.querySelectorAll('[data-sd-newsletter]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buscar);
  } else {
    buscar();
  }

  // El pop-up puede montarse tarde (modal perezoso del tema)
  new MutationObserver(buscar).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
